import { Reveal, Overline } from "@/components/Reveal";

const STEPS = [
  { n: "01", title: "Analizziamo il tuo locale", desc: "Ascoltiamo le tue esigenze e studiamo il tuo brand, i tuoi clienti e i tuoi obiettivi." },
  { n: "02", title: "Progettiamo la soluzione", desc: "Definiamo insieme strumenti, materiali e contenuti: nulla è lasciato al caso." },
  { n: "03", title: "Realizziamo tutto", desc: "Design, sviluppo, fotografia, video e produzione NFC. Ci pensiamo noi, dall'inizio alla fine." },
  { n: "04", title: "Il tuo locale è pronto", desc: "Consegniamo, configuriamo e ti affianchiamo. Da quel momento, ogni dettaglio lavora per te." },
];

const Process = () => (
  <section id="come-funziona" data-testid="process-section" className="marble-bg-soft relative py-28 lg:py-40">
    <div className="mx-auto max-w-[1440px] px-6 lg:px-12">
      <Reveal className="mb-24 max-w-2xl">
        <Overline className="mb-6">Come funziona</Overline>
        <h2 className="font-display text-4xl font-medium leading-[1.08] tracking-tight sm:text-5xl lg:text-6xl">
          Dal primo incontro<br />al <span className="gold-text italic">risultato finale.</span>
        </h2>
      </Reveal>

      <div className="relative grid gap-16 md:grid-cols-2 lg:grid-cols-4 lg:gap-10">
        <div className="gold-line absolute left-0 right-0 top-10 hidden h-px lg:block" aria-hidden="true" />
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.12 * i}>
            <div data-testid={`process-step-${s.n}`} className="group relative pt-2">
              <div className="relative z-10 mb-8 hidden h-2 w-2 rotate-45 border border-[#C19D60] bg-[#050505] transition-colors duration-500 group-hover:bg-[#C19D60] lg:block" style={{ marginTop: "30px", marginBottom: "42px" }} />
              <span className="font-display block text-7xl font-light leading-none text-transparent lg:text-8xl" style={{ WebkitTextStroke: "1px rgba(193,157,96,0.45)" }}>
                {s.n}
              </span>
              <h3 className="font-display mt-6 text-2xl font-medium tracking-tight text-[#F8F5F0]">{s.title}</h3>
              <p className="mt-3 text-sm font-light leading-relaxed text-[#A3A3A3]">{s.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Process;
